export default __webpack_public_path__ + "static/media/BBF-header-logo-white.e97ce224.svg";